import type React from 'react';

export interface IconPrimitiveProps extends React.SVGProps<SVGSVGElement> {
  size?: number
}

export type IconComponent = (props: IconPrimitiveProps) => React.ReactElement | null;

// Can we do this better? This will be true for any function, but we ideally want to check if it's a valid icon component
export function isIconComponent(component: unknown): component is IconComponent {
  return typeof component === 'function';
}
